import { Environment } from './environment';
import { environment } from '../../environments/environment';

/**
 * Returns the Environment configuration, depending on the host
 */
export function getEnvironment(): Environment {
    //TODO: Javi, when Azure Test and Load environments are ready, we need to update this function to return the correct URL
    const url = new URL(window.location.href);
    const hostname = url.hostname;
    const path = url.pathname;

    const signatureURLregexp = new RegExp(/^([0-9a-z-_])+(\.origoinc\.byappdirect\.com$)/, 'i');
    const signatureURLTestregexp = new RegExp(/^([0-9a-z-_])+(\.testcatalog\.appdirect\.com$)/, 'i');

    const configuration = new Environment();
    if (signatureURLregexp.test(hostname)) {
        configuration.backendUrl = `https://${hostname}/api/provider-sales/aso-stage/v1`;
        configuration.isIntegratedState = true;
        configuration.frontEndVersion = environment.frontEndVersion;
        configuration.frontEndBranch = environment.frontEndBranch;
        configuration.timestamp = environment.timestamp;
        configuration.frontendUrl = `https://${hostname}/provider-sales`;
        configuration.namespace = 'aso-stage';
        configuration.name = 'stage';
        configuration.backendUrlOutsideLoadBalancer = 'https://stage-aso-api.appsmart.com';
        return configuration;
    }

    switch (hostname) {
        case 'catalog.appdirect.com': // Production
            return getProductionEnvironment(configuration);
        case 'catalogsandbox.byappdirect.com': // Staging
            configuration.backendUrl = `https://${hostname}/api/provider-sales/aso-stage/v1`;
            configuration.isIntegratedState = true;
            configuration.frontEndVersion = environment.frontEndVersion;
            configuration.frontEndBranch = environment.frontEndBranch;
            configuration.timestamp = environment.timestamp;
            configuration.frontendUrl = 'https://catalogsandbox.byappdirect.com/provider-sales';
            configuration.namespace = 'aso-stage';
            configuration.name = 'stage';
            configuration.backendUrlOutsideLoadBalancer = 'https://stage-aso-api.appsmart.com';
            return configuration;
        case 'testcatalog.appdirect.com': // UAT
        case 'engage19billing.test.devappdirect.me': // Micro UI
            return getTestEnvironment(configuration, hostname);
        case 'appsmart.cyanopica.appdirect-test.io': // Azure Test
            configuration.backendUrl = `https://${hostname}/api/provider-sales/v1`;
            configuration.isIntegratedState = true;
            configuration.frontEndVersion = environment.frontEndVersion;
            configuration.frontEndBranch = environment.frontEndBranch;
            configuration.timestamp = environment.timestamp;
            configuration.frontendUrl = 'https://appsmart.cyanopica.appdirect-test.io/provider-sales';
            configuration.namespace = 'aso-azure';
            configuration.name = 'azure';
            configuration.backendUrlOutsideLoadBalancer = `https://${hostname}/api/provider-sales/v1`;
            return configuration;
        case 'pscatalog.loadtest.devappdirect.me': // Load
            configuration.backendUrl = `https://${hostname}/api/provider-sales/v1`;
            configuration.isIntegratedState = true;
            configuration.frontEndVersion = environment.frontEndVersion;
            configuration.frontEndBranch = environment.frontEndBranch;
            configuration.timestamp = environment.timestamp;
            configuration.frontendUrl = 'https://pscatalog.loadtest.devappdirect.me/provider-sales';
            configuration.namespace = 'aso-load';
            configuration.name = 'load';
            configuration.backendUrlOutsideLoadBalancer = 'https://pscatalog.loadtest.devappdirect.me';
            return configuration;
        case 'dataops.test.devappdirect.me': // DOPS
            configuration.backendUrl = `https://${hostname}/api/provider-sales/aso-dops/v1`;
            configuration.isIntegratedState = true;
            configuration.frontEndVersion = environment.frontEndVersion;
            configuration.frontEndBranch = environment.frontEndBranch;
            configuration.timestamp = environment.timestamp;
            configuration.frontendUrl = 'https://dataops.test.devappdirect.me/provider-sales';
            configuration.namespace = 'aso-dops';
            configuration.name = 'dops';
            configuration.backendUrlOutsideLoadBalancer = ''; // blank for now as it is broken
            return configuration;
        default:
            if (signatureURLTestregexp.test(hostname)) {
                return getTestEnvironment(configuration, hostname);
            }
            // Localhost
            configuration.backendUrl = `http://localhost:21021`;
            configuration.isIntegratedState = false;
            configuration.frontEndVersion = environment.frontEndVersion;
            configuration.frontEndBranch = environment.frontEndBranch;
            configuration.timestamp = environment.timestamp;
            configuration.frontendUrl = `http://localhost:4200${path.startsWith('/provider-sales') ? '/provider-sales' : ''}`;
            configuration.namespace = 'aso-local';
            configuration.name = 'local';
            configuration.backendUrlOutsideLoadBalancer = 'http://localhost:21021';
            return configuration;
    }
}

/*
 * returns the PRODUCTION Environment configuration
 * */
function getProductionEnvironment(configuration: Environment) {
    configuration.backendUrl = `https://catalog.appdirect.com/api/provider-sales/aso/v1`;
    configuration.isIntegratedState = true;
    configuration.frontEndVersion = environment.frontEndVersion;
    configuration.frontEndBranch = environment.frontEndBranch;
    configuration.timestamp = environment.timestamp;
    configuration.frontendUrl = 'https://catalog.appdirect.com/provider-sales';
    configuration.namespace = 'aso';
    configuration.name = 'production';
    configuration.backendUrlOutsideLoadBalancer = 'https://aso-api.appsmart.com';
    return configuration;
}

function getTestEnvironment(configuration: Environment, hostname: String) {
    configuration.backendUrl = `https://${hostname}/api/provider-sales/aso-uat/v1`;
    configuration.isIntegratedState = true;
    configuration.frontEndVersion = environment.frontEndVersion;
    configuration.frontEndBranch = environment.frontEndBranch;
    configuration.timestamp = environment.timestamp;
    configuration.frontendUrl = `https://${hostname}/provider-sales`;
    configuration.namespace = 'aso-uat';
    configuration.name = 'uat';
    configuration.backendUrlOutsideLoadBalancer = 'https://uat-aso-api.appsmart.com';
    return configuration;
}
